// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@awc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { userListHeaderStyles } from "@awc/Overrides/Widgets/UserList/UserListHeader";
import Search from "@awc/XDL/Icons/Search";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

userListHeaderStyles.searchGridItem = {
    width: 12,
    css: css`
        ${xScreen("lte", "sm")} {
            order: 2;
            padding-top: 8px;
        }
    `,
};

userListHeaderStyles.searchForm = {
    css: css`
        display: flex;
        justify-content: space-between;
        width: 100%;
        flex-direction: column;
    `,
};

userListHeaderStyles.searchSubmitButton = {
    variant: "tertiary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

userListHeaderStyles.cancelSeacrhButton = {
    variant: "secondary",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

userListHeaderStyles.buttonsWrapper = {
    css: css`
        display: flex;
        gap: 16px;
        justify-content: end;
        margin-top: 5px;
        ${xScreen("lte", "sm")} {
            flex-direction: column-reverse;
        }
    `,
};
userListHeaderStyles.buttonsGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
        padding-top: 21px;
        ${xScreen("lte", "sm")} {
            order: 2;
            max-width: 100%;
            flex-basis: 100%;
            & > button {
                width: 100%;
            }
        }
    `,
};

userListHeaderStyles.searchContainer = {
    css: css`
        padding: 10px 0;
    `,
};

userListHeaderStyles.userCountGridItem = {
    ...mergeWithCss(myAccountFilterSectionStyles.countGridItem, {
        css: css`
            ${xScreen("lte", "md")} {
                order: 1;
                justify-content: start;
                padding-bottom: 0;
            }
        `,
    }),
    width: [12, 12, 4, 6, 6],
};

userListHeaderStyles.searchTextField = {
    ...userListHeaderStyles.searchTextField,
    iconProps: { src: Search },
};

userListHeaderStyles.searchZoneGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${xScreen("lte", "sm")} {
            order: 3;
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

userListHeaderStyles.titleGridItem = { width: 12 };

userListHeaderStyles.titleContainer = {
    offsetCss: css`
        align-items: baseline;
    `,
};
